import { API_OPEN_PROFILE_IMAGE_URL } from "@daytrip/legacy-config";
import { ProfilePhotoStatus } from "@daytrip/legacy-enums";
import { plainToClass } from "class-transformer";

import type { CustomerFeedbackAggregableData } from "../models/CustomerFeedbackAggregableData";
import type { CustomerFeedbackForDriversCompany } from "../models/CustomerFeedbackForDriversCompany";
import { ProfilePhoto } from "../models/ProfilePhoto";
export function transformCustomerFeedbackAggregableDataToCustomerFeedbackForCompany(
    aggregableData: Array<CustomerFeedbackAggregableData>,
): Array<CustomerFeedbackForDriversCompany> {
    const result: Array<CustomerFeedbackForDriversCompany> = [];

    aggregableData.forEach((ad) => {
        if (ad.profilePhoto?.status === undefined) {
            ad.profilePhoto = plainToClass(ProfilePhoto, ad.profilePhoto);
        }

        const customerFeedbackForDriver = {
            originLocationName: ad.originLocationName,
            destinationLocationName: ad.destinationLocationName,
            departureAt: ad.departureAt,
            text: ad.feedback.text,
            textScore: ad.feedback.textScore,
            locationNames: ad.locationNames,
            driverName: ad.driverName,
            driverProfileImageUrl: ad.profilePhoto?.status === ProfilePhotoStatus.Accepted
                    ? `${API_OPEN_PROFILE_IMAGE_URL}?userId=${ad.feedback.driverUserId}`
                    : undefined,
        };

        result.push(customerFeedbackForDriver);
    });

    return result;
}
